import axios from 'axios'
import { API_ENDPOINT } from '../../../../../../config'

const getDefaultState = () => {
    return {
        disconnecting: false,
        flag: {
            type: "",
            text: ""
        }
    }
}

const disconnect = (instance) => {
    instance.setState({
        ...instance.state,
        disconnecting: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/customer/disconnect",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            id: instance.props.customer.id
        }
    }).then(response => handleDisconnectResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                disconnecting: false
            })
            alert(error)
        })
}

const handleDisconnectResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            break
        default:
            alert(response.data.message)
    }
    instance.props.onClose()
}

const Service = instance => {
    return {
        getDefaultState: () => getDefaultState(),
        disconnect: () => disconnect(instance)
    }
}

export default Service